import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import IDevelopmentsResolver from "@models/IDevelopmentsResolver.model";
import { Development } from "@models/development.model";
import { Project } from "@models/project.model";
import { ChartType } from "src/app/constants/charts-const";

@Component({
  selector: "app-developments",
  templateUrl: "./developments.component.html",
  styleUrls: ["./developments.component.scss"],
})
export class DevelopmentsComponent implements OnInit {
  mapZoomLevel = 9;
  development!: Development;

  chartTypeEnum = ChartType;
  selectedProject: Project | undefined = undefined;

  _project!: Project;
  projects: Project[] = [];

  constructor(public router: Router, public activatedRoute: ActivatedRoute) {}
  
  ngOnInit(): void {
   
    const data: IDevelopmentsResolver = this.activatedRoute.snapshot.data["developmentData"];

    this.development = data.development;

    try {
      const link = document.querySelector(".language-selector a") as HTMLAnchorElement;
      if (link) {
        link.href = `${window.location}#`;
      }
    } catch (error) {
      console.log(error);
    }

    this.projects = this.development?.areasOfWork.map((a) => a.projects).flat();

    if (screen.width < 500) {
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
  }

  closeModal(): void {
    this.selectedProject = undefined;
  }

  selectedProjectId(e: string): void {
    if (screen.width < 500) {
      const selectedProjectContainer = document.getElementById('selected-project-id');
      const noSelectedProjectContainer = document.getElementById('no-selected-project-id');
      if (this.selectedProject) {
        if (selectedProjectContainer) {
          selectedProjectContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      } else {
        if (noSelectedProjectContainer) {
          noSelectedProjectContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }
    this.selectedProject = this.projects.find((item) => item.id == e);
  }

  printPDF(): void {
    window.print();
  }
}
